// MOD-CUSTOM: Wire USP system into custom product recommendations

(function () {
  'use strict';

  function renderUsp() {
    var container = document.querySelector('[data-wetheme-section-type="custom-product-recommendations"]');
    if (!container || !window.UspEngine) return false;

    var productDataId = container.getAttribute('data-usp-product-data');
    if (!productDataId) return false;

    var productDataElement = document.getElementById(productDataId);
    var personaDataElement = document.getElementById('usp-persona-surface-data');

    var productData, personaData;
    try {
      productData = productDataElement ? JSON.parse(productDataElement.textContent) : [];
      personaData = personaDataElement ? JSON.parse(personaDataElement.textContent) : [];
    } catch (error) { return false; }

    window.UspEngine.renderUspInContainer(container, productData, personaData);
    return true;
  }

  // Content is static (no AJAX), so render as soon as USP engine is available.
  // UspEngine is loaded via safe-load-scripts which appends scripts dynamically
  // (defer is ignored on dynamic inserts), so we can't rely on document order alone.
  if (!renderUsp()) {
    var attempt = 0;
    var retryInterval = setInterval(function () {
      if (renderUsp() || attempt++ > 30) clearInterval(retryInterval);
    }, 100);
  }
}());
